import { AudioMixer } from "./AudioMixer";

export class MusicDucking {
  private active = false;

  constructor(private readonly mixer: AudioMixer) {}

  public isActive(): boolean {
    return this.active;
  }

  public duck(amount = 0.35, fadeMs = 120): void {
    this.active = true;
    this.mixer.setBusDuck("music", amount, fadeMs);
  }

  public unduck(fadeMs = 160): void {
    this.active = false;
    this.mixer.setBusDuck("music", 1, fadeMs);
  }
}